import axios from 'axios';

async function getVariants(itemId) {
    return new Promise(async (resolve, reject) => {
        let res = await axios.get(
            process.env.REACT_APP_BASE_URL + '/variants/' + itemId
        );
        resolve(res.data);
    });
}

async function getParts(partId) {
    return new Promise(async (resolve, reject) => {
        let res = await axios.post(
            process.env.REACT_APP_BASE_URL + '/part_lookup/',
            partId
        );
        resolve(res.data);
    });
}

async function getItemVersion(versionId) {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axios.get(
                process.env.REACT_APP_BASE_URL+ '/item_versions_public/'+ versionId
            );
            resolve(res.data);
        } catch (error) {
            console.debug(error)
            resolve(null)
        }

    });
}

async function searchVariantByOrder(orderId, searchString) {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axios.get(
                process.env.REACT_APP_BASE_URL+ '/variants_search/'+ orderId + searchString
            );
            resolve(res.data);
        } catch (error) {
            console.debug(error)
            resolve(null)
        }

    });
}

async function getMaterilJSON(url) {
    return new Promise(async (resolve, reject) => {
        try {
            let res = await axios.get(url);
            resolve(res.data);
        } catch (error) {
            console.debug(error)
            resolve(null)
        }
    });
};


export { getVariants, getParts, getItemVersion, getMaterilJSON, searchVariantByOrder };
